module.exports = __webpack_public_path__ + "img/card.1fb580ce.png";